import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Homepage } from './cero/main';

function App() {
  return <Homepage />;
}

export default App;
